(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2499],{

/***/ 6587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useInfiniteQuery; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+query-core@4.44.0/node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(4678);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+query-core@4.44.0/node_modules/@tanstack/query-core/build/lib/queryObserver.mjs
var queryObserver = __webpack_require__(5313);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+query-core@4.44.0/node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
var infiniteQueryBehavior = __webpack_require__(6098);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@tanstack+query-core@4.44.0/node_modules/@tanstack/query-core/build/lib/infiniteQueryObserver.mjs



class InfiniteQueryObserver extends queryObserver/* QueryObserver */.z {
  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(client, options) {
    super(client, options);
  }

  bindMethods() {
    super.bindMethods();
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }

  setOptions(options, notifyOptions) {
    super.setOptions({ ...options,
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }, notifyOptions);
  }

  getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return super.getOptimisticResult(options);
  }

  fetchNextPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam
        }
      }
    });
  }

  fetchPreviousPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam
        }
      }
    });
  }

  createResult(query, options) {
    var _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet, _state$data, _state$data2;

    const {
      state
    } = query;
    const result = super.createResult(query, options);
    const {
      isFetching,
      isRefetching
    } = result;
    const isFetchingNextPage = isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward';
    const isFetchingPreviousPage = isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward';
    return { ...result,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage,
      isFetchingPreviousPage,
      isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
    };
  }

}


//# sourceMappingURL=infiniteQueryObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.44.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs + 6 modules
var useBaseQuery = __webpack_require__(1382);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.44.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs
'use client';



function useInfiniteQuery(arg1, arg2, arg3) {
  const options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return (0,useBaseQuery/* useBaseQuery */.r)(options, InfiniteQueryObserver);
}


//# sourceMappingURL=useInfiniteQuery.mjs.map


/***/ }),

/***/ 1003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, default, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5271);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options, fallbackInView) {
  if (options === void 0) {
    options = {};
  }

  if (fallbackInView === void 0) {
    fallbackInView = unsupportedValue;
  }

  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap["delete"](id);
    }
  };
}

var _excluded = ["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"];

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay,
        fallbackInView = _this$props.fallbackInView;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    }, fallbackInView);
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        props = _objectWithoutPropertiesLoose(_this$props2, _excluded);

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView,
      fallbackInView = _ref.fallbackInView;

  var unobserve = react__WEBPACK_IMPORTED_MODULE_0__.useRef();

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      }, fallbackInView);
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 7271:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use client";
var e=__webpack_require__(2676),t=__webpack_require__(5271),n=__webpack_require__(967);const o=null,{min:r,max:i,abs:s,floor:l}=Math,c=(e,t,n)=>r(n,i(t,e)),d=e=>[...e].sort(((e,t)=>e-t)),f="function"==typeof queueMicrotask?queueMicrotask:e=>{Promise.resolve().then(e)},u=e=>{let t,n;return()=>(t||(t=!0,n=e()),n)},a=-1,h=(e,t,n)=>{const o=n?"unshift":"push";for(let n=0;n<t;n++)e[o](a);return e},v=(e,t)=>{const n=e.t[t];return n===a?e.o:n},p=(e,t,n)=>{const o=e.t[t]===a;return e.t[t]=n,e.i=r(t,e.i),o},g=(e,t)=>{if(!e.l)return 0;if(e.i>=t)return e.u[t];e.i<0&&(e.u[0]=0,e.i=0);let n=e.i,o=e.u[n];for(;n<t;)o+=v(e,n),e.u[++n]=o;return e.i=t,o},_=(e,t,n=0,o=e.l-1)=>{for(;n<=o;){const r=l((n+o)/2),i=g(e,r);if(i<=t){if(i+v(e,r)>t)return r;n=r+1}else o=r-1}return c(n,0,e.l-1)},m=(e,t,n)=>{const o=t-e.l;return e.i=n?-1:r(t-1,e.i),e.l=t,o>0?(h(e.u,o),h(e.t,o,n),e.o*o):(e.u.splice(o),(n?e.t.splice(0,-o):e.t.splice(o)).reduce(((t,n)=>t-(n===a?e.o:n)),0))},w="undefined"!=typeof window,S=()=>document.documentElement,$=e=>e.ownerDocument,x=e=>e.defaultView,y=/*#__PURE__*/u((()=>!!w&&"rtl"===getComputedStyle(S()).direction)),b=/*#__PURE__*/u((()=>/iP(hone|od|ad)/.test(navigator.userAgent))),I=/*#__PURE__*/u((()=>"scrollBehavior"in S().style)),z=e=>i(e.h(),e.v()),k=e=>!!e.v(),T=(e,t=40,n=4,l=0,c,f=!1)=>{let u=!!l,w=1,S=0,$=0,x=0,y=0,I=0,z=0,k=0,T=0,R=u?[0,i(l-1,0)]:o,E=[0,0],M=0;const C=((e,t,n)=>({o:n?n[1]:t,t:n&&n[0]?h(n[0].slice(0,r(e,n[0].length)),i(0,e-n[0].length)):h([],e),l:e,i:-1,u:h([],e)}))(e,t,c),H=new Set,W=()=>x-$,O=()=>W()+I+y,q=e=>((e,t,n,o)=>{if(o=r(o,e.l-1),g(e,o)<=t){const r=_(e,t+n,o);return[_(e,t,o,r),r]}{const r=_(e,t,void 0,o);return[r,_(e,t+n,r)]}})(C,e,S,E[0]),B=()=>(e=>e.l?g(e,e.l-1)+v(e,e.l-1):0)(C),J=e=>g(C,e)-I,L=e=>v(C,e),P=e=>{e&&(b()&&0!==k?I+=e:y+=e)};return{p:()=>w,_:()=>(e=>[e.t.slice(),e.o])(C),m:()=>{let e,t;return z?[e,t]=E:([e,t]=E=q(i(0,O())),R&&(e=r(e,R[0]),t=i(t,R[1]))),1!==k&&(e-=i(0,n)),2!==k&&(t+=i(0,n)),[i(e,0),r(t,C.l-1)]},S:()=>_(C,O()),$:()=>_(C,O()+S),I:e=>C.t[e]===a,k:()=>!!R&&C.t.slice(i(0,R[0]-1),r(C.l-1,R[1]+1)+1).includes(a),T:J,R:L,M:()=>C.l,C:()=>x,H:()=>0!==k,v:()=>S,W:()=>$,h:B,O:()=>(z=y,y=0,[z,2===T||W()+S>=B()]),q:(e,t)=>{const n=[e,t];return H.add(n),()=>{H.delete(n)}},B:(e,t)=>{let n,r,l=0;switch(e){case 1:{const e=z;z=0;const n=t-x,i=s(n);e&&i<s(e)+1||0!==T||(k=n<0?2:1),u&&(R=o,u=!1),x=t,l=4;const c=W();c>=-S&&c<=B()&&(l+=1,r=i>S);break}case 2:l=8,0!==k&&(n=!0,l+=1),k=0,T=0,R=o;break;case 3:{const e=t.filter((([e,t])=>C.t[e]!==t));if(!e.length)break;P(e.reduce(((e,[t,n])=>((2===T||(R?!u&&t<R[0]:J(t)+(0===k&&0===T?L(t):0)<W()))&&(e+=n-L(t)),e)),0));for(const[t,n]of e){const e=L(t),o=p(C,t,n);f&&(M+=o?n:n-e)}f&&S&&M>S&&(P(((e,t)=>{let n=0;const o=[];e.t.forEach(((e,r)=>{e!==a&&(o.push(e),r<t&&n++)})),e.i=-1;const r=d(o),s=r.length,l=s/2|0,c=s%2==0?(r[l-1]+r[l])/2:r[l],f=e.o;return((e.o=c)-f)*i(t-n,0)})(C,_(C,O()))),f=!1),l=3,r=!0;break}case 4:S!==t&&(S=t,l=3);break;case 5:t[1]?(P(m(C,t[0],!0)),T=2,l=1):(m(C,t[0]),l=1);break;case 6:$=t;break;case 7:T=1;break;case 8:R=q(t),l=1}l&&(w=1+(2147483647&w),n&&I&&(y+=I,I=0),H.forEach((([e,t])=>{l&e&&t(r)})))}}},R=setTimeout,E=(e,t)=>t&&y()?-e:e,M=(e,t,n,r,i,s)=>{const l=Date.now;let c=0,d=!1,f=!1,u=!1,a=!1;const h=(()=>{let t;const n=()=>{t!=o&&clearTimeout(t)},r=()=>{n(),t=R((()=>{t=o,(()=>{if(d||f)return d=!1,void h();u=!1,e.B(2)})()}),150)};return r.J=n,r})(),v=()=>{c=l(),u&&(a=!0),s&&e.B(6,s()),e.B(1,r()),h()},p=t=>{if(d||!e.H()||t.ctrlKey)return;const o=l()-c;150>o&&50<o&&(n?t.deltaX:t.deltaY)&&(d=!0)},g=()=>{f=!0,u=a=!1},_=()=>{f=!1,b()&&(u=!0)};return t.addEventListener("scroll",v),t.addEventListener("wheel",p,{passive:!0}),t.addEventListener("touchstart",g,{passive:!0}),t.addEventListener("touchend",_,{passive:!0}),{L:()=>{t.removeEventListener("scroll",v),t.removeEventListener("wheel",p),t.removeEventListener("touchstart",g),t.removeEventListener("touchend",_),h.J()},P:()=>{const[t,o]=e.O();t&&(i(E(t,n),o,a),a=!1,o&&e.v()>e.h()&&e.B(1,r()))}}},C=(e,t)=>{let n,o,r;const i=t?"scrollLeft":"scrollTop",s=t?"overflowX":"overflowY",l=async(o,s)=>{if(!n)return void f((()=>l(o,s)));r&&r();const c=()=>{let t;return[new Promise(((n,o)=>{t=n,r=o,k(e)&&R(o,150)})),e.q(2,(()=>{t&&t()}))]};if(s&&I()){for(;e.B(8,o()),e.k();){const[e,t]=c();try{await e}catch(e){return}finally{t()}}n.scrollTo({[t?"left":"top"]:E(o(),t),behavior:"smooth"})}else for(;;){const[r,s]=c();try{n[i]=E(o(),t),e.B(7),await r}catch(e){return}finally{s()}}};return{A(l){n=l,o=M(e,l,t,(()=>E(l[i],t)),((t,n,o)=>{if(o){const e=l.style,t=e[s];e[s]="hidden",R((()=>{e[s]=t}))}n?(l[i]=e.C()+t,r&&r()):l[i]+=t}))},X(){o&&o.L()},Y(e){l((()=>e))},j(t){t+=e.C(),l((()=>t))},D(t,{align:n,smooth:o,offset:r=0}={}){if(t=c(t,0,e.M()-1),"nearest"===n){const o=e.T(t),r=e.C();if(o<r)n="start";else{if(!(o+e.R(t)>r+e.v()))return;n="end"}}l((()=>r+e.W()+e.T(t)+("end"===n?e.R(t)-e.v():"center"===n?(e.R(t)-e.v())/2:0)),o)},U:()=>{o&&o.P()}}},H=(e,t)=>{let n,o,r;const i=(e,t,n,o,r=0)=>{const s=o?"offsetLeft":"offsetTop",l=r+(o&&y()?n.innerWidth-e[s]-e.offsetWidth:e[s]),c=e.offsetParent;return e!==t&&c?i(c,t,n,o,l):l},s=async(o,i)=>{if(!n)return void f((()=>s(o,i)));r&&r();const l=()=>{let t;return[new Promise(((n,o)=>{t=n,r=o,k(e)&&R(o,150)})),e.q(2,(()=>{t&&t()}))]},c=x($(n));if(i&&I()){for(;e.B(8,o()),e.k();){const[e,t]=l();try{await e}catch(e){return}finally{t()}}c.scroll({[t?"left":"top"]:E(o(),t),behavior:"smooth"})}else for(;;){const[n,r]=l();try{c.scroll({[t?"left":"top"]:E(o(),t)}),e.B(7),await n}catch(e){return}finally{r()}}};return{A(r){n=r;const s=t?"scrollX":"scrollY",l=$(r),c=x(l),d=l.body;o=M(e,c,t,(()=>E(c[s],t)),((n,o)=>{o?c.scroll({[t?"left":"top"]:e.C()+n}):c.scrollBy(t?n:0,t?0:n)}),(()=>i(r,d,c,t)))},X(){o&&o.L(),n=void 0},U:()=>{o&&o.P()},D(o,{align:r,smooth:l,offset:d=0}={}){if(!n)return;if(o=c(o,0,e.M()-1),"nearest"===r){const t=e.T(o),n=e.C();if(t<n)r="start";else{if(!(t+e.R(o)>n+e.v()))return;r="end"}}const f=$(n),u=x(f),a=f.documentElement,h=()=>e.v()-(t?a.clientWidth:a.clientHeight);s((()=>d+i(n,f.body,u,t)+e.T(o)+("end"===r?e.R(o)-(e.v()-h()):"center"===r?(e.R(o)-(e.v()-h()))/2:0)),l)}}},W=(e,t)=>{const n=C(e,!1),o=C(t,!0);return{A(e){n.A(e),o.A(e)},X(){n.X(),o.X()},Y(e,t){n.Y(t),o.Y(e)},j(e,t){n.j(t),o.j(e)},D(e,t){n.D(t),o.D(e)},U(){n.U(),o.U()}}},O=e=>{let t;return{V(n){(t||(t=new(x($(n)).ResizeObserver)(e))).observe(n)},F(e){t.unobserve(e)},L(){t&&t.disconnect()}}},q=(e,t)=>{let n;const r=t?"width":"height",i=new WeakMap,s=O((t=>{const s=[];for(const{target:l,contentRect:c}of t)if(l.offsetParent)if(l===n)e.B(4,c[r]);else{const e=i.get(l);e!=o&&s.push([e,c[r]])}s.length&&e.B(3,s)}));return{G(e){s.V(n=e)},K:(e,t)=>(i.set(e,t),s.V(e),()=>{i.delete(e),s.F(e)}),X:s.L}},B=(e,t)=>{const n=t?"width":"height",r=t?"innerWidth":"innerHeight",i=new WeakMap,s=O((t=>{const r=[];for(const{target:e,contentRect:s}of t){if(!e.offsetParent)continue;const t=i.get(e);t!=o&&r.push([t,s[n]])}r.length&&e.B(3,r)}));let l;return{G(t){const n=x($(t)),o=()=>{e.B(4,n[r])};n.addEventListener("resize",o),o(),l=()=>{n.removeEventListener("resize",o)}},K:(e,t)=>(i.set(e,t),s.V(e),()=>{i.delete(e),s.F(e)}),X(){l&&l(),s.L()}}},J=(e,t)=>{let n;const o="height",r="width",s=new WeakMap,l=new Set,c=new Set,d=new Map,f=(e,t)=>`${e}-${t}`,u=O((u=>{const a=new Set,h=new Set;for(const{target:i,contentRect:l}of u)if(i.offsetParent)if(i===n)e.B(4,l[o]),t.B(4,l[r]);else{const e=s.get(i);if(e){const[t,n]=e,i=f(t,n),s=d.get(i),c=[l[o],l[r]];let u,v;s?(s[0]!==c[0]&&(u=!0),s[1]!==c[1]&&(v=!0)):u=v=!0,u&&a.add(t),v&&h.add(n),(u||v)&&d.set(i,c)}}if(a.size){const t=[];a.forEach((e=>{let n=0;c.forEach((t=>{const o=d.get(f(e,t));o&&(n=i(n,o[0]))})),n&&t.push([e,n])})),e.B(3,t)}if(h.size){const e=[];h.forEach((t=>{let n=0;l.forEach((e=>{const o=d.get(f(e,t));o&&(n=i(n,o[1]))})),n&&e.push([t,n])})),t.B(3,e)}}));return{G(e){u.V(n=e)},K:(e,t,n)=>(s.set(e,[t,n]),l.add(t),c.add(n),u.V(e),()=>{s.delete(e),u.F(e)}),X:u.L}},L=w?t.useLayoutEffect:t.useEffect,P="current",A=(e,t)=>{if(Array.isArray(e))for(const n of e)A(n,t);else null==e||"boolean"==typeof e||t.push(e)},X=(e,t)=>{const n=e.key;return null!=n?n:"_"+t},Y=e=>{const n=t.useRef();return n[P]||(n[P]=e())},j=e=>{const n=t.useRef(e);return L((()=>{n[P]=e}),[e]),n},D=t.memo((({N:n,Z:o,ee:r,te:i,ne:s,oe:l,re:c,ie:d})=>{const f=t.useRef(null);L((()=>o(f[P],r)),[r]);const u=t.useMemo((()=>{const e={position:s&&d?void 0:"absolute",[c?"height":"width"]:"100%",[c?"top":"left"]:0,[c?y()?"right":"left":"top"]:i,visibility:!s||d?"visible":"hidden"};return c&&(e.display="flex"),e}),[i,s,d,c]);return"string"==typeof l?e.jsx(l,{ref:f,style:u,children:n}):e.jsx(l,{ref:f,style:u,index:r,children:n})})),U=(e,n)=>t.useMemo((()=>{if("function"==typeof e)return[e,n||0];const t=(e=>{const t=[];return A(e,t),t})(e);return[e=>t[e],t.length]}),[e,n]),V=t.forwardRef((({children:o,count:r,overscan:i,itemSize:s,shift:l,horizontal:c,keepMounted:u,cache:a,startMargin:h=0,ssrCount:v,as:p="div",item:g="div",scrollRef:_,onScroll:m,onScrollEnd:w},S)=>{const[$,x]=U(o,r),y=t.useRef(null),b=t.useRef(!!v),I=j(m),k=j(w),[R,E,M,H]=Y((()=>{const e=!!c,t=T(x,s,i,v,a,!s);return[t,q(t,e),C(t,e),e]}));x!==R.M()&&R.B(5,[x,l]),h!==R.W()&&R.B(6,h);const[W,O]=t.useReducer(R.p,void 0,R.p),[B,J]=R.m(),A=R.H(),V=R.h(),F=[],G=t=>{const n=$(t);return e.jsx(D,{Z:E.K,ee:t,te:R.T(t),ne:R.I(t),oe:g,N:n,re:H,ie:b[P]},X(n,t))};L((()=>{b[P]=!1;const e=R.q(1,(e=>{e?n.flushSync(O):O()})),t=R.q(4,(()=>{I[P]&&I[P](R.C())})),o=R.q(8,(()=>{k[P]&&k[P]()})),r=e=>{E.G(e),M.A(e)};return _?f((()=>r(_[P]))):r(y[P].parentElement),()=>{e(),t(),o(),E.X(),M.X()}}),[]),L((()=>{M.U()}),[W]),t.useImperativeHandle(S,(()=>({get cache(){return R._()},get scrollOffset(){return R.C()},get scrollSize(){return z(R)},get viewportSize(){return R.v()},findStartIndex:R.S,findEndIndex:R.$,getItemOffset:R.T,getItemSize:R.R,scrollToIndex:M.D,scrollTo:M.Y,scrollBy:M.j})),[]);for(let e=B,t=J;e<=t;e++)F.push(G(e));if(u){const e=[],t=[];d(u).forEach((n=>{n<B&&e.push(G(n)),n>J&&t.push(G(n))})),F.unshift(...e),F.push(...t)}return e.jsx(p,{ref:y,style:{overflowAnchor:"none",flex:"none",position:"relative",visibility:"hidden",width:H?V:"100%",height:H?"100%":V,pointerEvents:A?"none":void 0},children:F})})),F=t.forwardRef((({children:n,count:o,overscan:r,itemSize:i,shift:s,horizontal:l,keepMounted:c,reverse:d,cache:f,ssrCount:u,item:a,onScroll:h,onScrollEnd:v,style:p,...g},_)=>{const m=t.useRef(null),w=d&&!l;let S=e.jsx(V,{ref:_,scrollRef:w?m:void 0,count:o,overscan:r,itemSize:i,shift:s,horizontal:l,keepMounted:c,cache:f,ssrCount:u,item:a,onScroll:h,onScrollEnd:v,children:n});return w&&(S=e.jsx("div",{style:{visibility:"hidden",display:"flex",flexDirection:"column",justifyContent:"flex-end",minHeight:"100%"},children:S})),e.jsx("div",{ref:m,...g,style:{display:l?"inline-block":"block",[l?"overflowX":"overflowY"]:"auto",contain:"strict",width:"100%",height:"100%",...p},children:S})})),G=t.forwardRef((({children:o,count:r,overscan:i,itemSize:s,shift:l,horizontal:c,cache:d,ssrCount:f,as:u="div",item:a="div",onScroll:h,onScrollEnd:v},p)=>{const[g,_]=U(o,r),m=t.useRef(null),w=j(h),S=j(v),$=t.useRef(!!f),[x,y,b,I]=Y((()=>{const e=!!c,t=T(_,s,i,f,d,!s);return[t,B(t,e),H(t,e),e]}));_!==x.M()&&x.B(5,[_,l]);const[z,k]=t.useReducer(x.p,void 0,x.p),[R,E]=x.m(),M=x.H(),C=x.h(),W=[];L((()=>{$[P]=!1;const e=x.q(1,(e=>{e?n.flushSync(k):k()})),t=x.q(4,(()=>{w[P]&&w[P]()})),o=x.q(8,(()=>{S[P]&&S[P]()})),r=m[P];return y.G(r),b.A(r),()=>{e(),t(),o(),y.X(),b.X()}}),[]),L((()=>{b.U()}),[z]),t.useImperativeHandle(p,(()=>({get cache(){return x._()},findStartIndex:x.S,findEndIndex:x.$,scrollToIndex:b.D})),[]);for(let t=R,n=E;t<=n;t++){const n=g(t);W.push(e.jsx(D,{Z:y.K,ee:t,te:x.T(t),ne:x.I(t),oe:a,N:n,re:I,ie:$[P]},X(n,t)))}return e.jsx(u,{ref:m,style:{flex:"none",position:"relative",visibility:"hidden",width:I?C:"100%",height:I?"100%":C,pointerEvents:M?"none":void 0},children:W})})),K=(e,t)=>`${e}-${t}`,N=t.memo((({N:n,Z:o,se:r,le:i,ce:s,de:l,fe:c,ue:d,ne:f,ae:u})=>{const a=t.useRef(null);return L((()=>o.K(a[P],r,i)),[i,r]),e.jsx(u,{ref:a,style:t.useMemo((()=>({display:"grid",position:"absolute",top:s,[y()?"right":"left"]:l,visibility:f?"hidden":"visible",minHeight:c,minWidth:d})),[s,l,d,c,f]),children:n})})),Q=t.forwardRef((({children:o,row:r,col:i,cellHeight:s=40,cellWidth:l=100,overscan:c=2,initialRowCount:d,initialColCount:f,item:u="div",onScroll:a,onScrollEnd:h,style:v,...p},g)=>{const[_,m,w,S]=Y((()=>{const e=T(r,s,c,d),t=T(i,l,c,f);return[e,t,J(e,t),W(e,t)]}));r!==_.M()&&_.B(5,[r]),i!==m.M()&&m.B(5,[i]);const[$,x]=t.useReducer(_.p,void 0,_.p),[y,b]=t.useReducer(m.p,void 0,m.p),[I,k]=_.m(),[R,E]=m.m(),M=_.H(),C=m.H(),H=z(_),O=z(m),q=t.useRef(null),B=j(a),A=j(h);L((()=>{const e=q[P],t=_.q(1,(e=>{e?n.flushSync(x):x()})),o=m.q(1,(e=>{e?n.flushSync(b):b()})),r=_.q(4,(()=>{B[P]&&B[P](_.C())})),i=_.q(8,(()=>{A[P]&&A[P]()}));return w.G(e),S.A(e),()=>{t(),o(),w.X(),S.X(),r(),i()}}),[]),L((()=>{S.U()}),[$,y]),t.useImperativeHandle(g,(()=>({get scrollTop(){return _.C()},get scrollLeft(){return m.C()},get scrollHeight(){return z(_)},get scrollWidth(){return z(m)},get viewportHeight(){return _.v()},get viewportWidth(){return m.v()},findStartIndex:()=>[m.S(),_.S()],findEndIndex:()=>[m.$(),_.$()],getItemOffset:(e,t)=>[m.T(e),_.T(t)],getItemSize:(e,t)=>[m.R(e),_.R(t)],scrollToIndex:S.D,scrollTo:S.Y,scrollBy:S.j})),[]);const X=t.useMemo((()=>{const e=new Map;return(t,n)=>{let r=e.get(K(t,n));return r||e.set(K(t,n),r=o({rowIndex:t,colIndex:n})),r}}),[o]),D=[];for(let t=I;t<=k;t++)for(let n=R;n<=E;n++)D.push(e.jsx(N,{Z:w,se:t,le:n,ce:_.T(t),de:m.T(n),fe:_.R(t),ue:m.R(n),ne:_.I(t)||m.I(n),ae:u,N:X(t,n)},K(t,n)));return e.jsx("div",{ref:q,...p,style:{overflow:"auto",contain:"strict",width:"100%",height:"100%",...v},children:e.jsx("div",{style:{overflowAnchor:"none",flex:"none",position:"relative",visibility:"hidden",width:O,height:H,pointerEvents:M||C?"none":void 0},children:D})})}));exports.VList=F,exports.Virtualizer=V,exports.WindowVirtualizer=G,exports.experimental_VGrid=Q;
//# sourceMappingURL=index.js.map


/***/ })

}]);